export const ARWEAVE_GRAPHQL = 'https://arweave.net/graphql'
export const TAG_DOMAIN = window.location.host
export const ARWEAVE_NODE = 'https://arweave.net'
export const REACT_APP_INFURA_PROJECT_ID = '273c16c48360429b910360f9a0591015'
export const WC_PROJECT = 'b37b0256619f642e4ce39ed8df18668d'